<template>
    <div class="content-w scrollable">
        <div class="">
            <div class="content-box">
                <!--START - Recent Ticket Comments-->
                <div class="element-wrapper" v-if="formMode == 'view'">
                    <div class="element-actions d-none d-sm-block">
                        <a class="btn btn-primary btn-sm" @click="formMode = 'add'">
                            <i class="os-icon os-icon-ui-22"></i>
                            Add Rule
                        </a>
                    </div>
                    <Loader v-if="isLoading == true" />
                    <div class="element-box-tp" v-else>
                        <EmptyState v-if="!pagination.data">
                            <div slot="empty_state_text">
                                There are no completion rules
                            </div>
                        </EmptyState>
                        <div class="table-responsive" v-else>
                            <table class="table table-padded">
                                <thead>
                                    <tr>
                                        <th>Rule ID</th>
                                        <th>Name</th>
                                        <th>Channel</th>
                                        <th>Brand</th>
                                        <th>Category</th>
                                        <th>Gender</th>
                                        <th>Completion Rule</th>
                                        <th>Status</th>
                                        <th>Last Updated</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="rule in pagination.data">
                                        <td>CR{{rule.id_completion_rule}}</td>
                                        <td>{{rule.name}}</td>
                                        <td>{{rule.channel_name || 'All Channels'}}</td>
                                        <td>{{rule.brand || 'All Brands'}}</td>
                                        <td>{{rule.category_name || 'All Categories'}}</td>
                                        <td>{{rule.gender || 'All Genders'}}</td>
                                        <td>
                                            <div class="required-session" v-for="(session) in stringToArray(rule.required_session)">
                                                {{session}} Session<br />
                                            </div>
                                        </td>
                                        <td class="nowrap">
                                            <div v-html="formatTemplateStatus(rule)"></div>
                                            <div class="pt-1" @click="updateRule(rule.id_completion_rule, rule.is_active)">
                                               <a v-if="rule.is_active == 0" class="btn btn-sm small btn-primary">Activate</a>
                                               <a v-else class="btn btn-sm small btn-danger text-white">Deactivate</a>
                                            </div>
                                        </td>
                                        <td>
                                            <span>{{rule.updated_at}}</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                        <Pagination v-if="pagination.last_page > 1 " :pagination="pagination" @paginate="getRules()" :offset="5"></Pagination>
                    </div>
                </div>
                <div class="element-wrapper" v-if="formMode == 'add'">
                    <h6 class="element-header">Add Completion Rule</h6>
                    <div class="element-box p-10">
                        <form class="row" id="addCompletionRule">
                            <div class="col-sm-6">
                                <div class="form-group">
                                    <label for=""> Rule Name</label>
                                    <input name="name" class="form-control" placeholder="Rule Name" type="text">
                                </div>
                                <div class="form-group">
                                    <label for=""> Channel</label>
                                    <select name="id_channel" class="form-control">
                                        <option value="">Select an option</option>
                                        <option v-for="(channel,index) in channels" :value="channel.id_channel">{{channel.channel_name}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for=""> Gender</label>
                                    <select name="gender" class="form-control">
                                        <option value="">Select an option</option>
                                        <option v-for="(gender, index) in genders" :value="gender.gender">{{gender.gender}}</option>
                                    </select>
                                </div>
                                <div class="form-group">
                                    <label for=""> Category</label>
                                    <select name="id_category" class="form-control">
                                        <option value="">Select an option</option>
                                        <option v-for="(category, index) in categories" :value="category.id_category">{{category.category_name}}</option>
                                    </select>
                                </div>
                            </div>
                            <div class="col-sm-6 support-index">

                                <div class="support-ticket-content-w ">
                                    <div class="support-ticket-info">
                                        <div class="info-section">
                                            <ul class="users-list as-tiles">
                                                <li v-for="session in required_sessions" @click="session.selected = !session.selected">
                                                    <a class="author with-avatar" :class="{'selected': session.selected}">
                                                        <i :class="session.icon" class="session-icon"></i>
                                                        <span>{{session.name}} Session</span>
                                                    </a>
                                                </li>
                                            </ul>
                                        </div>
                                    </div>
                                </div>

                            </div>
                            <div class="col-sm-12">
                                <div class="form-buttons-w text-right">
                                    <a class="btn btn-primary" @click="formMode = 'view'">Cancel</a>
                                    <button class="btn btn-primary" @click.prevent="submitForm">Submit</button>
                                </div>
                            </div>

                        </form>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Pagination from '@/components/common/Pagination'
import EmptyState from '@/components/common/EmptyState'
import Loader from '@/components/common/Loader'

import FormMixin from '@/mixins/forms.js'

import CommonFunctions from '@/mixins/common-functions.js'

export default {
  mixins: [CommonFunctions, FormMixin],
  components: {
    Pagination,
    EmptyState,
    Loader
  },
  data: function () {
    return {
      isLoading: true,
      formMode: 'view',
      pagination: {
        current_page: 1
      },
      required_sessions: [
        {
          name: 'product',
          icon: 'fal fa-camera',
          selected: false
        },
        {
          name: 'model',
          icon: 'fal fa-portrait',
          selected: false
        },
        {
          name: 'flat',
          icon: 'fal fa-image',
          selected: false
        }
      ],
      channels: [],
      brands: [],
      categories: [],
      genders: []
    }
  },
  mounted: function () {
    var self = this
    $('.select2').select2()
    this.getRules()
  },
  methods: {
    getRules: function () {
      var self = this
      const url =
        '/orgdesk/completionrules?page=' + this.pagination.current_page
      let data = {
        page: this.pagination.current_page
      }
      self.isLoading = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.pagination = response.data.rules
          self.brands = response.data.brands
          self.channels = response.data.channels
          self.categories = response.data.categories
          self.genders = response.data.genders
          self.isLoading = false
        })
        .catch(function (error) {
          self.isLoading = false
        })
    },
    updateRule: function (id_completion_rule, is_active) {
      var self = this
      const url = '/orgdesk/completionrule/update'
      let data = {
        id_completion_rule: id_completion_rule,
        is_active: is_active == 0 ? 1 : 0
      }
      self.isLoading = true
      this.$http
        .post(url, data, {
          dataType: 'json',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          }
        })
        .then(function (response) {
          self.getRules()
        })
        .catch(function (error) {
          self.isLoading = false
        })
    },
    formatTemplateStatus: function (rule) {
      var response = ''
      if (rule.is_active == 1) {
        response =
          '<span class="status-pill smaller green"></span><span>Active</span>'
      } else {
        response =
          '<span class="status-pill smaller red"></span><span>Inactive</span>'
      }

      return response
    },
    submitForm () {
      this.submitCompletionRuleForm()
    }
  }
}
</script>

<style scoped>
.selected {
  border: 3px solid #75da62;
}
.support-index .support-ticket-content-w .support-ticket-info {
  flex: 0 0 100%;
}
.support-index
  .support-ticket-content-w
  .support-ticket-info
  ul.users-list.as-tiles
  li {
  flex: 0 0 49%;
}
.support-index
  .support-ticket-content-w
  .support-ticket-info
  ul.users-list.as-tiles
  li
  a {
  padding: 40px;
}
.support-index
  .support-ticket-content-w
  .support-ticket-info
  ul.users-list.as-tiles
  li
  a
  span {
  font-size: 16px;
  text-transform: capitalize;
}

.session-icon {
  font-size: 44px;
}
.profile-tile .profile-tile-box {
  width: 100px;
}

.required-session {
  text-transform: capitalize;
}

select > option {
  border: 1px solid #ddd;
  width: 100px;
  display: inline-block;
}

.small{
    font-size: 10px;

    padding: 3px;
}
</style>
